import * as React from "preact";

const ColumnData = [
  { label: "Bank", accessor: "bankName", type: "string" },
  { label: "AER rate", accessor: "aerRate", type: "number" },
  { label: "Gross rate", accessor: "grossRate", type: "number" },
  { label: "Product type", accessor: "productType", type: "string" },
  { label: "Notice period (days)", accessor: "featureNoticePeriod", type: "number" },
  { label: "Fixed term period (months)*", accessor: "featureTermPeriod", type: "number" },
  { label: "Minimum deposit", accessor: "minDeposit", type: "currency" },
  { label: "Maximum deposit", accessor: "maxDeposit", type: "currency", hiddenOn: "JOINT" },
  { label: "Maximum deposit", accessor: "jointMaxDeposit", type: "currency", shownOn: "JOINT" },
  { label: "Sharia", accessor: "sharia", type: "string" },
];

export default ColumnData;
